// Sağlık raporu KVKK maskeleme: dosya türü tespiti, maskeleme penceresini açma ve belge yükleme yardımcıları
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const HEALTH_KEY = 'saglik_raporu';
export const MASK_HOWTO_KEY = 'mask-howto-seen';
export const MASK_FIX_PREFIX = 'Maskeleme düzeltmesi';
export const MASK_FIX_LABEL = 'Maskeleme Düzeltmesi Bekleniyor';
export const MASK_FIX_REASONS = [
  'Teşhis / tanı bilgisi açık',
  'Tetkik / tahlil sonucu açık',
  'Gereksiz kişisel sağlık verileri açık',
  'Belgenin gerekli bölümleri yanlışlıkla maskelenmiş',
  'Diğer',
];

export const isHealthDoc = (entityType, docKey) => entityType === 'employees' && docKey === HEALTH_KEY;
export const isMaskFix = (note) => typeof note === 'string' && note.startsWith(MASK_FIX_PREFIX);

// Dosya türü uzantıdan ve gerçek içerikten (ilk baytlar) doğrulanır
export const detectFileType = async (file) => {
  const ext = (file.name || '').split('.').pop().toLowerCase();
  if (!['pdf', 'jpg', 'jpeg', 'png'].includes(ext)) throw new Error('Sağlık raporu için yalnızca PDF, JPG, JPEG veya PNG yükleyebilirsiniz');
  const b = new Uint8Array(await file.slice(0, 8).arrayBuffer());
  const isPdf = b[0] === 0x25 && b[1] === 0x50 && b[2] === 0x44 && b[3] === 0x46;
  const isJpg = b[0] === 0xff && b[1] === 0xd8 && b[2] === 0xff;
  const isPng = b[0] === 0x89 && b[1] === 0x50 && b[2] === 0x4e && b[3] === 0x47;
  const real = isPdf ? 'pdf' : isJpg ? 'jpeg' : isPng ? 'png' : null;
  const expected = ext === 'jpg' ? 'jpeg' : ext;
  if (!real || real !== expected) throw new Error('Dosya içeriği uzantısıyla uyuşmuyor veya dosya bozuk');
  return ext;
};

let openFn = null;
export const registerHealthMask = (fn) => { openFn = fn; };
// Maskeleme penceresini açar; yükleme tamamlanınca dosya bilgisi, vazgeçilirse null döner
export const openHealthMask = (opts) => new Promise((resolve) => {
  if (!openFn) { resolve(null); return; }
  openFn({ ...opts, resolve });
});

export const uploadMaskedPages = (employeeId, { blobs, sourceType, mode, rectCount, originalName, correction }) => {
  const body = new FormData();
  blobs.forEach((b, i) => body.append('pages', b, `sayfa-${i + 1}.${b.type === 'image/png' ? 'png' : 'jpg'}`));
  body.append('source_type', sourceType);
  body.append('mode', mode);
  body.append('rect_count', String(rectCount));
  body.append('original_filename', originalName || '');
  body.append('correction', correction || '');
  return axios.post(`${API}/employees/${employeeId}/health-report`, body);
};

// Ortak belge yükleme: sağlık raporu her zaman maskeleme ekranından geçer
export const postDocFile = async (entityType, entityId, docKey, file, params) => {
  if (isHealthDoc(entityType, docKey)) {
    const info = await openHealthMask({ file, employeeId: entityId });
    if (!info) { const err = new Error('cancelled'); err.cancelled = true; throw err; }
    return { data: info };
  }
  const body = new FormData();
  body.append('file', file);
  return axios.post(`${API}/${entityType}/${entityId}/document-files/${docKey}`, body, { params });
};
